import React from "react";
import Reveal from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";
import { TECHNOLOGY } from "@/data/content";

export default function Technology() {
  return (
    <div data-testid="technology-page" className="pt-32">
      <section className="relative overflow-hidden py-16 md:py-24">
        <div className="mesh-bg">
          <div className="mesh-blob" style={{ width: 440, height: 440, background: "#F5C86B", top: -100, left: -60 }} />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F28C82]">Technology</p>
            <h1 className="mt-6 font-heading text-4xl font-light tracking-tighter text-[#4B2E5A] md:text-6xl">
              Intelligence that understands your life
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-[#4B2E5A]/70">
              Naari is built on a stack of modern AI capabilities that learn from context, preference and behavior to make better everyday decisions with you.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="mx-auto max-w-6xl px-6 md:px-12">
          <div className="grid gap-6 md:grid-cols-3 md:gap-8">
            {TECHNOLOGY.map((t, i) => (
              <Reveal key={t.title} delay={i * 0.08}>
                <div className="glass h-full rounded-[24px] p-8">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#B8E3D9]/40">
                    <t.icon className="h-7 w-7 text-[#4B2E5A]" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-medium text-[#4B2E5A]">{t.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#4B2E5A]/60">
                    Applied across every Naari product to personalize recommendations and reduce cognitive load.
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Newsletter />
    </div>
  );
}
